import {Tabs} from '@material-ui/core'
import ReportsTabContext, {
  ReportsTabContextProps,
} from 'modules/reports/components/Tab/ReportsTab.context'
import useMount from 'modules/reports/hooks/mount'
import usePrefix from 'modules/reports/hooks/prefix'
import React, {useMemo, useState, useCallback} from 'react'
import useStyles from './ReportsTabSlider.styles'

type TabRenderer = () => React.ReactNode

type Props = {
  children: React.ReactNode
  'data-testid': string
  contentClassName?: string
}

function ReportsTabSlider(props: Props) {
  const {children, contentClassName} = props
  const classes = useStyles()
  const p = usePrefix(props['data-testid'])

  const [value, setValue] = useState({index: 0, renderer: () => null as React.ReactNode})
  const tabRenderers: TabRenderer[] = useMemo(() => [], [])

  const handleChange = (_: React.ChangeEvent<{}>, newIndex: number) => {
    setValue({index: newIndex, renderer: tabRenderers[newIndex]})
  }

  const setRenderer = useCallback(
    (index: number, renderer: () => React.ReactNode) => {
      tabRenderers[index] = renderer
    },
    [tabRenderers]
  )

  useMount(() => {
    setValue({index: value.index, renderer: tabRenderers[value.index]})
  })

  const count = tabRenderers.length || React.Children.count(children)
  const contextValue: ReportsTabContextProps = useMemo(() => ({setRenderer, count}), [
    setRenderer,
    count,
  ])

  return (
    <div className={classes.root} data-testid={p()}>
      <ReportsTabContext.Provider value={contextValue}>
        <Tabs
          className={classes.tabs}
          value={value.index}
          onChange={handleChange}
          data-testid={props['data-testid']}
          indicatorColor="primary"
          textColor="primary"
        >
          {children}
        </Tabs>

        <div className={`${classes.content} ${contentClassName}`}>
          {value.renderer ? value.renderer() : 'Unable to render tab'}
        </div>
      </ReportsTabContext.Provider>
    </div>
  )
}

export default ReportsTabSlider
